/** Поля, які форма надсилає; решта значень картки (статус, uuid, розрахункові) — ні */
const BASE_FIELDS = ['code', 'shiftDate', 'driver', 'vehicle', 'cluster', 'region']
const START_FIELDS = ['startedAt', 'startOdometer', 'documentsConfirmed', 'safetyBriefingConfirmed']
/** Пробіг Wialon вносить диспетчер, доки немає інтеграції: з ним рахується контроль пробігу */
const COMPLETE_FIELDS = ['completedAt', 'endOdometer', 'technicalRemarks', 'wialonMileage']

/** Які поля можна правити залежно від статусу (дані початку/завершення — лише після дії) */
export const writableShiftFields = (status: string | undefined): string[] => {
    if (status === 'completed') return [...BASE_FIELDS, ...START_FIELDS, ...COMPLETE_FIELDS]
    if (status === 'started') return [...BASE_FIELDS, ...START_FIELDS]
    return BASE_FIELDS
}
